
export default {
  success: {},
  error: {
    
    first_name: "First name is required",
    last_name: "Last name is required",
    phone_number: "Phone number is required",
    country: "Country is required",
    address1: "Address1 is required",
    address2: "Address2 is required",
    city: "City is required",
    state: "State is required",
    other_state: "OtherState is required",
    zip: "Zip is required",
    enter_email: "Please enter email",
    email_format: "Email format is not correct",
    enter_password: "Enter password",
    confirm_password: "required !",
    password_mismatch: "Passwords does not match",
    adminLevel:"Admin Level is required",
  },
  warn: {},
  info: {}
};
